import React, { useMemo } from 'react';
import TPTabs from 'components/TP-UI/TPTabs';
import PropTypes from 'prop-types';
import { getAvailableRoutingHubs } from 'helpers/hubs';

const TabsContainer = ({ availableHubs, ...props }) => {
  const hubs = useMemo(() => (availableHubs ? availableHubs : getAvailableRoutingHubs()), [
    availableHubs,
  ]);

  return <TPTabs {...props} availableHubs={hubs} />;
};

TabsContainer.propTypes = {
  ...TPTabs.propTypes,
  availableHubs: PropTypes.arrayOf(PropTypes.string),
};

export default TabsContainer;
